module.exports = __webpack_public_path__ + "static/media/ImgMBTI_ROIA.ed2b7107.png";